export default __webpack_public_path__ + "static/media/evaluasi.02dec1ee.svg";